import wrapper from './wrapper';


function addConsentChangedCallback(callback) {
	return wrapper.addChangeCallback(callback);
}


function openCMPSettings() {
	return wrapper.openSettings();
}


function hasTrackingConsent() {
	return wrapper.hasCategoryConsent('tracking');
}


function hasPersonalizationConsent() {
	return wrapper.hasCategoryConsent('personalization');
}


function hasTwitterConsent() {
	return wrapper.hasCategoryConsent('twitter');
}


function hasInstagramConsent() {
	return wrapper.hasCategoryConsent('instagram');
}


function hasFacebookConsent() {
	return wrapper.hasCategoryConsent('facebook');
}


function hasThirdPartyConsent() {
	return wrapper.hasCategoryConsent('thirdparty');
}


function setTrackingConsent(state) {
	return wrapper.setCategoryConsent('tracking', state);
}


function setPersonalizationConsent(state) {
	return wrapper.setCategoryConsent('personalization', state);
}


function setTwitterConsent(state) {
	return wrapper.setCategoryConsent('twitter', state);
}


function setInstagramConsent(state) {
	return wrapper.setCategoryConsent('instagram', state);
}


function setFacebookConsent(state) {
	return wrapper.setCategoryConsent('facebook', state);
}


function setThirdPartyConsent(state) {
	return wrapper.setCategoryConsent('thirdparty', state);
}


function setAllConsent(state) {
	return wrapper.setCategoryConsent('all', state);
}


export {
	addConsentChangedCallback,
	openCMPSettings,
	hasTrackingConsent,
	hasPersonalizationConsent,
	hasTwitterConsent,
	hasInstagramConsent,
	hasFacebookConsent,
	hasThirdPartyConsent,
	setTrackingConsent,
	setPersonalizationConsent,
	setTwitterConsent,
	setInstagramConsent,
	setFacebookConsent,
	setThirdPartyConsent,
	setAllConsent,
};
